import { ProductComponent } from './../../../components/product/product.component';
import { WebSiteUsersService } from '@app/services/webSiteUsers/webSiteUsers.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component } from '@angular/core';
import { PdvService } from '@app/services/pdv/pdv.service';
import { FamilyService } from '@app/services/family/family.service';
@Component({
    moduleId: module.id,
    selector: 'confirmation-account',
    templateUrl: 'confirmation-account.component.html',
    styleUrls: ['confirmation-account.component.scss'],
    providers:[PdvService,FamilyService]
})
export class ConfirmationAccountComponent {
    confirme=false;
    aleardyConfirmed=false;
    error=false;
    loading=true;
    idUser;
    key;
    displayBestSales: boolean=false;
    families: any[] = [];
    constructor(
        public route: ActivatedRoute,
        public router: Router,
        private webuser:WebSiteUsersService,
        private pdvService:PdvService,
        private familyService:FamilyService,
    ){
        
    }
    ngOnInit(){
        this.route.params.subscribe(params => {
            this.key=params['key'];
            this.idUser = params['user'];
            this.webuser.confirme(this.idUser,this.key).subscribe(
                (data:any)=>{
                    this.loading=false;
                    if(data.code == 1){
                        this.error=false;
                        this.confirme=true;
                        this.aleardyConfirmed=false;
                    }else{
                        this.error=false;
                        this.confirme=false;
                        this.aleardyConfirmed=true;
                    }
                   
                },
                (err)=>{
                    this.loading=false;
                    this.error=true;
                }
            )
        })
        this.getFamiliesOfCarte();
        this.pdvService.pdv.subscribe(
            (pdv: any) => {
                if (pdv) {
                    this.displayBestSales = pdv.displayBestSales;
                }
            }
        )
    }

    getFamiliesOfCarte() {
        this.familyService.getFamiliesOfCarte().subscribe(
            (families: any[]) => {
                this.families = families;
                console.log(families)
            }
        )
    }

    goToCarte() {
        if (this.displayBestSales) {
            this.router.navigate(['/carte/top-des-ventes'])
        } else {

            this.router.navigate(['/carte/famille/' + this.families[0].slug])
        }
    }
}
